export default "__VITE_ASSET__DEpx9fwM__"